export default __webpack_public_path__ + "static/media/banner4.8d9aed48.png";